<template>
    <modal
        type="custom"
        v-if="showModal"
        :showDismiss="true"
        @backdrop="$emit('hide')"
    >
        <div class="flex flex-col">
            <slot name="logo">
                <img
                    :src="logoUrl"
                    alt="TryHaLa"
                    class="w-32 my-4 self-center"
                />
            </slot>

            <slot name="buttons">
                <div class="text-darkGrayishBlue text-xl text-center mt-4">
                    {{ '想買就快啲去登記成為「試吓啦」會員啦!' }}
                </div>
                <div class="mt-8 flex justify-between">
                    <router-link
                        tag="button"
                        class="btn btn-white py-2 text-xl justify-center sm:flex-grow-0 sm:px-16"
                        :class="{ 'w-full': !enableCreateAccount }"
                        :to="{
                            path: previewCmpyToken
                                ? `/login/${previewCmpyToken}`
                                : '/login',
                            params: { lastRoute: lastRoute }
                        }"
                        @click.native="$emit('hide')"
                    >
                        {{ $t('register.already.registered') }}
                    </router-link>

                    <router-link
                        v-if="enableCreateAccount"
                        tag="button"
                        class="btn btn-primary py-2 text-xl justify-center sm:flex-grow-0 sm:px-16"
                        :to="`/createAccount/${previewCmpyToken}`"
                        @click.native="$emit('hide')"
                    >
                        {{ $t('register.register.now') }}
                    </router-link>
                </div>
            </slot>
        </div>
    </modal>
</template>

<script>
import modal from '@/components/modal.vue';
import { previewProductRedirectRouteNameMapper } from '../router';
import logo6_optimized from '@/assets/logo6_optimized.png';

export default {
    components: {
        modal
    },
    props: {
        showModal: { type: Boolean, default: false }
    },
    created() {
        this.logoUrl = logo6_optimized;
    },
    computed: {
        previewCmpyToken() {
            return this.$store.getters.previewCmpyToken;
        },
        lastRoute() {
            const name =
                previewProductRedirectRouteNameMapper[this.$route.name] ||
                this.$route.name;
            return {
                name: name,
                params: this.$route.params
            };
        },
        enableCreateAccount() {
            return this.$store.state.enblCreAcct;
        }
    }
};
</script>
